import { writable } from 'svelte/store';

function loadInitial() {
  if (typeof localStorage === 'undefined') return {
    selectedTab: 'upload',
    selectedFeature: null,
    isLoading: false,
    loadingText: '',
    showFeatureModal: false,
    editHistory: [],
    currentEditIndex: -1,
    dogFact: null,
    dashboardTasks: [],
    currentTaskId: null,
    hideOverlayForCurrentTask: false
  };
  const saved = localStorage.getItem('erion_edit_store');
  if (saved) {
    try {
      const data = JSON.parse(saved);
      if (data && Array.isArray(data.dashboardTasks)) {
        const seen = new Set();
        data.dashboardTasks = data.dashboardTasks.filter(task => {
          if (seen.has(task.id)) return false;
          seen.add(task.id);
          return true;
        });
      }
      return { ...data, dashboardTasks: Array.isArray(data.dashboardTasks) ? data.dashboardTasks : [],
        editHistory: Array.isArray(data.editHistory) ? data.editHistory : [],
        currentEditIndex: Number.isInteger(data.currentEditIndex) ? data.currentEditIndex : -1,
        isLoading: false, isLoadingInDashboard: false, hideOverlayForCurrentTask: false };
    } catch (e) {
      console.error('failed to parse edit store', e);
    }
  }
  return {
    selectedTab: 'upload',
    selectedFeature: null,
    isLoading: false,
    loadingText: '',
    showFeatureModal: false,
    editHistory: [],
    currentEditIndex: -1,
    dogFact: null,
    dashboardTasks: [],
    currentTaskId: null,
    hideOverlayForCurrentTask: false
  };
}

// 편집 관련 상태를 관리하는 스토어
export const editStore = writable(loadInitial());

export function resetEditStore() {
  editStore.set({
    selectedTab: 'upload',
    selectedFeature: null,
    isLoading: false,
    loadingText: '',
    showFeatureModal: false,
    editHistory: [],
    currentEditIndex: -1,
    dogFact: null,
    dashboardTasks: [],
    currentTaskId: null,
    hideOverlayForCurrentTask: false
  });
}

if (typeof localStorage !== 'undefined') {
  editStore.subscribe(value => {
    try {
      localStorage.setItem('erion_edit_store', JSON.stringify(value));
    } catch (e) {
      console.error('failed to save edit store', e);
    }
  });
}